import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromFollowPrediction from '../reducers/follow-prediction.reducer';
export const selectFollowedPredictionState = createFeatureSelector<fromFollowPrediction.State>('followedPrediction');
export const selectFollowedPredictions = createSelector(
    selectFollowedPredictionState,
    (state: fromFollowPrediction.State) => state.followedPredictions
);
export const selectFollowedPredictionErrorMessage = createSelector(
    selectFollowedPredictionState,
    (state: fromFollowPrediction.State) => state.errorMessage
);
export const selectIsFollowedPredictionLoading = createSelector(
    selectFollowedPredictionState,
    (state: fromFollowPrediction.State) => state.isLoading
);

